/**
 * 常量
 */
module.exports = {
  /**
   * @description 请求超时时间，毫秒（默认2分钟）
   */
  timeout: 1200000,
}
